import React from 'react'

import { Main } from 'components/ActionStyles/ActionStyles'
import { useDispatch } from 'react-redux'
import ErrorMessage from 'utils/ErrorMessage'
import { getSingleCorporateData } from '../../../actions'
import Button from 'components/Button'
import { LoginOutlined } from '@ant-design/icons'

const ActionDropdown = ({ rowData, setViewCorporateDrawer }) => {
  const dispatch = useDispatch()

  const callBackError = msg => {
    ErrorMessage(msg || 'No Corporate Found')
  }

  const onClickView = () => {
    dispatch(
      getSingleCorporateData(rowData?.id || rowData?._id, callBackError)
    )
  }

  return (
    <Main>
      <Button.IconButton
        textAlign="center"
        icon={<LoginOutlined />}
        onClick={onClickView}
        disabled={!rowData?.id && !rowData?._id}
        text="Checkin"
        height="38px"
      />
    </Main>
  )
}

export default ActionDropdown
